import { MetricTypes } from 'tabs/data/api/generated/models'
// type MetricsType = 'TEXT' | 'DECIMAL' | 'BOOLEAN' | 'ENUM' | 'JSON'

export const MetricsTypes: Record<MetricTypes, MetricTypes> = {
  TEXT: 'TEXT',
  DECIMAL: 'DECIMAL',
  BOOLEAN: 'BOOLEAN',
  // OUR CUSTOM TYPES
  ENUM: 'ENUM',
  // JSON: 'JSON',
}
